import { Component, OnInit } from '@angular/core';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  loader: boolean = false;
  brandData = appConstants?.commonAppConstants?.brandData;
  constructor() {
    
  }

  ngOnInit(): void {
    this.loader = true;
  }

}
